import React from 'react';
import './cta.css';

const CTA = () => {
  return (
    <div className="gpt3__cta">
      <div className="gpt3__cta-content">
        <p>Ready to start moving better?</p>
        <h3>Schedule a physical therapy evaluation in Crown Point.</h3>
      </div>
      <div className="gpt3__cta-btn">
        <button type="button">Call (518) 597-4678</button>
      </div>
    </div>
  )
}
export default CTA
